export const SUPER_ADMIN_PAGES = [
  { path: "/bookings-management", aliases: ["/bookings"], label: "Bookings Management" },
  { path: "/rankings-management", label: "Rankings" },
  { path: "/reports-management", label: "Reports Management" },
  { path: "/payments-management", label: "Payments Management" },
  { path: "/extended-analytics", label: "Extended Analytics" },
  // P96 — Marketing: the newsletters' subscribers (accounts and the site box's guests, with their addresses)
  { path: "/marketing", label: "Marketing" },
  { path: "/system-settings", label: "System Settings" },
  { path: "/tournament-feedback", label: "Tournament feedback" },
  { path: "/settings/partners", label: "Partners" },
  // The global Logistics section: its warehouse, sheets, shipments, stock, catalogue, estimates and settings.
  { path: "/logistics", label: "Logistics" },
  // The Events Planner: tournament proposals stay internal (PRD story 1).
  { path: "/events-planner", label: "Events Planner" },
]

export const isSuperAdmin = user => user?.role === "superAdmin"
export const canAccessEventTab = (user, tab) => !tab?.superAdminOnly || isSuperAdmin(user)
// Only a SuperAdmin creates events, so every creation passes the Logistics card (the API refuses others).
export const canCreateEvent = user => isSuperAdmin(user)
export const canAccessCpPage = (user, pathname) => {
  const path = String(pathname || "").toLowerCase().replace(/\/+$/, "")
  const restricted = SUPER_ADMIN_PAGES.some(page =>
    [page.path, ...(page.aliases || [])].some(prefix => path === prefix || path.startsWith(prefix + "/"))
  )
  return !restricted || isSuperAdmin(user)
}
